import store from '../redux/store';

import { DataRefreshInterval } from "./constants/SystemConstants";
import { DispatchAF } from './AFStoreDispatchAction';
import * as ReduxDataStatus from '../utils/constants/ReduxDataStatus';
import * as AFStateHelper from './AFStateHelper';
import { ClientType } from "./constants/Consts";


/// Clients
/////////////////
export const RefreshClientsCachedData = () => {
    const reduxStore = store.getState();

    var refreshingData = false;
    if(reduxStore.auth.isAuthenticated) {
        const dataAgeSec = Math.round((Date.now() - reduxStore.clients.loadTime) / 1000);
        if(dataAgeSec > DataRefreshInterval.clientsSec) {
            console.log(`Clients loaded seconds: ${dataAgeSec} -> Refreshing`);
            refreshingData = true;
            DispatchAF.fetchAllClients();
        }    
    }

    return refreshingData;
}

export const RefreshClientSubcontractantiCachedData = (clientId) => {
    const reduxStore = store.getState();

    if(reduxStore.auth.isAuthenticated) {
        const dataAgeSec = Math.round((Date.now() - reduxStore.clientSubcontractors.loadTime) / 1000);

        if( !reduxStore.clientSubcontractors.loadCriteria.clientId  ||                           // no load criteria
            reduxStore.clientSubcontractors.loadCriteria.clientId != clientId ||                 // different load criteria 
            dataAgeSec > DataRefreshInterval.clientsSec) {                                 // old data

            console.log(`Client Subcontractors loaded seconds: ${dataAgeSec} -> Refreshing`);
            DispatchAF.fetchClientSubcontractanti(clientId);
        }    
    }
}


export const RefreshClientSubcontractedCachedData = (clientId) => {
    const reduxStore = store.getState();

    if(reduxStore.auth.isAuthenticated) {
        const dataAgeSec = Math.round((Date.now() - reduxStore.clientSubcontracted.loadTime) / 1000);

        if( !reduxStore.clientSubcontracted.loadCriteria.clientId  ||                     // no load criteria
            reduxStore.clientSubcontracted.loadCriteria.clientId != clientId ||           // different load criteria 
            dataAgeSec > DataRefreshInterval.clientsSec) {                                 // old data

            console.log(`Client Subcontracted loaded seconds: ${dataAgeSec} -> Refreshing`);
            DispatchAF.fetchSubcontracted(clientId);
        }    
    }
}


// Users
///////////////
export const RefreshUsersCachedData = (clientId) => {
    const reduxStore = store.getState();

    if(reduxStore.auth.isAuthenticated && clientId) {
        const dataAgeSec = Math.round((Date.now() - reduxStore.users.loadTime) / 1000);
        if( !reduxStore.users.loadCriteria.clientId  ||                                 // no load criteria
            reduxStore.users.loadCriteria.clientId != clientId ||                       // different load criteria 
            dataAgeSec > DataRefreshInterval.generalSec) {                              // old data
            console.log(`Users loaded seconds: ${dataAgeSec} -> Refreshing`);
            DispatchAF.fetchUsers(clientId);
        }    
    }
}


// Employers
////////////////
export const RefreshEmployersByEIDCachedData = (employerId) => {
    const reduxStore = store.getState();

    var refreshingData = false;
    if(reduxStore.auth.isAuthenticated) {

        const dataAgeSec = Math.round((Date.now() - reduxStore.employers.loadTime) / 1000);
        if( !reduxStore.employers.loadCriteria.employerId  ||                               // no load criteria
            reduxStore.employers.loadCriteria.employerId != employerId ||                   // different load criteria 
            dataAgeSec > DataRefreshInterval.employersSec) {                                // old data

            console.log(`Employers loaded seconds: ${dataAgeSec} -> Refreshing`);
            refreshingData = true;
            DispatchAF.fetchEmployer(employerId);
        }    
    }

    return refreshingData;
}

export const RefreshEmployersByCIDCachedData = (clientId) => {
    const reduxStore = store.getState();

    var refreshingData = false;
    if(reduxStore.auth.isAuthenticated) {

        const dataAgeSec = Math.round((Date.now() - reduxStore.employers.loadTime) / 1000);
        if( !reduxStore.employers.loadCriteria.clientId  ||                                 // no load criteria
            reduxStore.employers.loadCriteria.clientId != clientId ||                       // different load criteria 
            dataAgeSec > DataRefreshInterval.employersSec) {                                // old data

            console.log(`Employers loaded seconds: ${dataAgeSec} -> Refreshing`);
            refreshingData = true;
            DispatchAF.fetchEmployersForClient(clientId);
        }    
    }
    return refreshingData;
}


export const RefreshWorksiteByEIDCachedData = (employerId) => {
    const reduxStore = store.getState();

    if(reduxStore.auth.isAuthenticated) {

        const contextClientId = AFStateHelper.getContextClientId();

        const dataAgeSec = Math.round((Date.now() - reduxStore.worksites.loadTime) / 1000);
        if (!reduxStore.worksites.loadCriteria.employerId ||                                // No load criteria - Employer
            !reduxStore.worksites.loadCriteria.eClientId ||                                 // No load criteria - Client (could be a client who subcontracted, therefore restricted WS)
            reduxStore.worksites.loadCriteria.employerId != employerId ||                   // Different load criteria
            reduxStore.worksites.loadCriteria.eClientId != contextClientId ||               // Different load criteria
            dataAgeSec > DataRefreshInterval.employersSec                                   // Old data
        ) {
            console.log(`Worksites loaded seconds: ${dataAgeSec} -> Refreshing`);
            DispatchAF.fetchWorksitesForEmployer(employerId);
        }
    }
}


export const RefreshWorksiteByCIDCachedData = (clientId) => {
    const reduxStore = store.getState();

    if(reduxStore.auth.isAuthenticated) {

        const dataAgeSec = Math.round((Date.now() - reduxStore.worksites.loadTime) / 1000);
        if (!reduxStore.worksites.loadCriteria.clientId ||                              // No load criteria
            reduxStore.worksites.loadCriteria.clientId != clientId ||                   // Different load criteria
            dataAgeSec > DataRefreshInterval.employersSec                               // Old data
        ) {
            console.log(`Worksites loaded seconds: ${dataAgeSec} -> Refreshing`);
            DispatchAF.fetchWorksitesForClient(clientId);
        }
    }
}



// Employees
////////////
export const EmployeesDataLoader = () => {
    const reduxStore = store.getState();

    RefreshClientsCachedData();
    if(reduxStore.clients.status === ReduxDataStatus.SUCCEEDED) {
        const contextClientId = AFStateHelper.getContextClientId();
        const clientType = AFStateHelper.getClientType(contextClientId);
    
        if(clientType === ClientType.Angajator) {
            EmployerEmployeesDataLoader();
        }
        else if(clientType === ClientType.ServicuExtern) {
            ServiceProviderEmployeesDataLoader();
        }
        // else -> we should not be here.....
    }
}

const EmployerEmployeesDataLoader = () => {
    console.log("++++ EmployerEmployeesDataLoader")

    const contextClientId = AFStateHelper.getContextClientId();
    const myEmployerId = AFStateHelper.getClientEmployerEID(contextClientId);

    RefreshEmployersByEIDCachedData(myEmployerId);
    RefreshEmployeesCachedData(myEmployerId);
    RefreshWorksiteByEIDCachedData(myEmployerId);
}


const ServiceProviderEmployeesDataLoader = async () => {
    const reduxStore = store.getState();

    console.log("++++ ServiceProviderEmployeesDataLoader")
    const contextClientId = AFStateHelper.getContextClientId();

    const refreshingData = RefreshEmployersByCIDCachedData(contextClientId);
    if(refreshingData) {
        // we do not know what employees to load so wait for the next refresh cycle
        DispatchAF.setBucketValue({employeeFilter: {...reduxStore.bucket.bucket.employeeFilter, employerId: null, worksiteId: -1}});
        return;
    }

    var employerId;
    if(reduxStore.bucket.bucket.employeeFilter?.employerId){
        employerId = reduxStore.bucket.bucket.employeeFilter.employerId;
    }
    else if(reduxStore.employers.employers.length > 0){
        employerId = reduxStore.employers.employers[0].id;
    }
    else{ 
        // No employers loaded, we don't know which employees to load
        return;
    }

    RefreshEmployeesCachedData(employerId);
    RefreshWorksiteByEIDCachedData(employerId);
}

export const RefreshEmployeesCachedData = (employerId) => {
    const reduxStore = store.getState();

    if(reduxStore.auth.isAuthenticated) {

        const dataAgeSec = Math.round((Date.now() - reduxStore.employees.loadTime) / 1000);
        if( !reduxStore.employees.loadCriteria.employerId  ||                               // no load criteria
                reduxStore.employees.loadCriteria.employerId != employerId ||               // different load criteria 
                dataAgeSec > DataRefreshInterval.generalSec) {                              // old data
            console.log(`Employees loaded seconds: ${dataAgeSec} -> Refreshing`);
            DispatchAF.fetchEmployees(employerId);
        }
    }
}


export const RefreshRsvtiOperators = (worksiteId, clientId) => {
    const reduxStore = store.getState();

    if(reduxStore.auth.isAuthenticated) {

        const dataAgeSec = Math.round((Date.now() - reduxStore.rsvtiOperators.loadTime) / 1000);
        if( !reduxStore.rsvtiOperators.loadCriteria.clientId ||                         // No load criteria
            !reduxStore.rsvtiOperators.loadCriteria.worksiteId ||                       // No load criteria
            reduxStore.rsvtiOperators.loadCriteria.clientId != clientId ||              // different load criteria
            reduxStore.rsvtiOperators.loadCriteria.worksiteId != worksiteId ||          // different load criteria
            dataAgeSec > DataRefreshInterval.generalSec ) {                             // old data
            
            console.log(`RSVTI Operators loaded seconds: ${dataAgeSec} -> Refreshing`);
            DispatchAF.fetchRsvtiOperators(clientId, worksiteId);
        }
    }
}

// Is it necessary to cache the Authorizations???
export const RefreshAuthzsCache = (employeeId) => {
    const reduxStore = store.getState();

    if(reduxStore.auth.isAuthenticated) {

        const dataAgeSec = Math.round((Date.now() - reduxStore.authorizations.loadTime) / 1000);
        if( !reduxStore.authorizations.loadCriteria.employeeId ||                      // No load criteria
            reduxStore.authorizations.loadCriteria.employeeId != employeeId ||         // different load criteria
            dataAgeSec > DataRefreshInterval.generalSec ) {                            // old data
            
            console.log(`Authz loaded seconds: ${dataAgeSec} -> Refreshing`);
            DispatchAF.fetchAuthzs(employeeId);
            DispatchAF.fetchCourses(employeeId);
        }
    }
}


//// Tasks
//////////
export const RefreshTasksCachedData = (clientId) => {
    const reduxStore = store.getState();

    if(reduxStore.auth.isAuthenticated) {

        const dataAgeSec = Math.round((Date.now() - reduxStore.rsvtiTasks.loadTime) / 1000);
        if( !reduxStore.rsvtiTasks.loadCriteria.clientId ||                 // No load criteria
            reduxStore.rsvtiTasks.loadCriteria.clientId != clientId ||      // different load criteria
            dataAgeSec > DataRefreshInterval.generalSec ) {                         // old data

            console.log(`RSVTI Tasks loaded seconds: ${dataAgeSec} -> Refreshing`);
            DispatchAF.fetchRsvtiTasks(clientId);
        }
    }
}
